import { FC } from "react";
import { Line } from "react-chartjs-2";
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
} from "chart.js";
import { useTranslation } from "react-i18next";
import { OrderSummaryResource } from "@/models/homePage";

interface IHomePageOrderChart {
    orderSummary: OrderSummaryResource | null;
}

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ArcElement,
    Tooltip,
    Legend
);

const HomePageOrderChart: FC<IHomePageOrderChart> = (props: IHomePageOrderChart) => {
    const { t } = useTranslation();

    const chartOptions = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: false,
            },
        },
    };

    const labels = props.orderSummary?.orderSummaryLabels ?? [];

    const chartData = {
        labels,
        datasets: [
            {
                label: t("homepage.WithSubsidies"),
                data: props.orderSummary?.ordersWithSubsidies,
                borderColor: "#F1B670",
                backgroundColor: "#F1B670",
                tension: 0.4,
            },
            {
                label: t("homepage.TotalOrders"),
                data: props.orderSummary?.totalOrders,
                borderColor: "#4373A1",
                backgroundColor: "#4373A1",
                tension: 0.4,
            },
            {
                label: t("homepage.WithoutSubsidies"),
                data: props.orderSummary?.ordersWithoutSubsidies,
                borderColor: "#3C8B6F",
                backgroundColor: "#3C8B6F",
                tension: 0.4,
            },
        ],
    };

    return <Line options={chartOptions} data={chartData} />;
};

export default HomePageOrderChart;
